import { useMutation } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/base";
import { captureException } from "@/services/log";

export interface SimilarIdea {
  id: string;
  titulo: string;
  descricao: string;
  similarity: number;
}

interface FindSimilarIdeasRequest {
  titulo: string;
  descricao: string;
  licenciadaId?: string;
  empresaId: string;
  maxResults?: number;
  minSimilarity?: number;
}

interface FindSimilarIdeasResponse {
  similarIdeas: SimilarIdea[];
}

/**
 * Hook para verificar se há ideias similares antes de criar uma nova
 * @returns Mutation para verificar similaridade
 */
export function useCheckSimilarIdeas() {
  const findSimilarIdeasFunction = httpsCallable<FindSimilarIdeasRequest, FindSimilarIdeasResponse>(
    functions,
    "ideiasFunctions-findSimilarIdeas"
  );

  return useMutation({
    mutationFn: async (parameters: FindSimilarIdeasRequest) => {
      try {
        const result = await findSimilarIdeasFunction(parameters);
        return result.data.similarIdeas;
      } catch (error) {
        captureException(error as Error, true);
        throw error;
      }
    }
  });
}
